/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import styled from 'styled-components';
import { TextField, FormLabel, FormControl, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import RequiredLabel from '@ui-elements/RequiredLabel';
import { StandardTextFieldProps } from '@mui/material/TextField';
import { FONT_SIZES, PALETTE } from '~/assets/styles/base';

const TextBoxWrapper = styled.div`
  width: 100%;
  background: ${PALETTE.white};
`;

type StyleOutlinedTextboxProps = {
  $width: string;
};

const StyleOutlinedTextbox = styled(TextField)<StyleOutlinedTextboxProps>`
  textarea {
    width: ${({ $width }) => $width};
    font-size: ${FONT_SIZES.bodyDefault};
  }
`;

const StyledFormLabel = styled(FormLabel)`
  font-size: ${FONT_SIZES.bodyDefault};
  margin-bottom: 10px;
`;

type Props = {
  label: string;
  name?: string;
  handleChange?: StandardTextFieldProps['onChange'];
  handleBlur?: StandardTextFieldProps['onBlur'];
  value?: string | number;
  rows?: number;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
  type?: string;
  dataTestId?: string;
  error?: boolean;
  width?: string;
  labelColor?: string;
  // ↓inputPropsは動的なのでいったんlintエラーは無視してobjectで定義
  inputProps?: {};
};

const TextFieldWithLabel: React.FC<Props & StandardTextFieldProps> = ({
  label,
  name,
  handleChange,
  handleBlur,
  value,
  rows = 1,
  required = false,
  disabled = false,
  helperText = '',
  type = 'text',
  labelColor = 'primary',
  dataTestId = 'uiParts-TextFieldWithLabel',
  error,
  width = '580px',
  inputProps = {},
}): JSX.Element => (
  <Box sx={{ padding: 2 }}>
    <FormControl fullWidth>
      {required ? (
        <StyledFormLabel>
          <RequiredLabel />
          <Typography variant="title2" data-testid="TextFieldWithLabel-Lable" color={labelColor}>
            {label}
          </Typography>
        </StyledFormLabel>
      ) : (
        <StyledFormLabel>
          <Typography variant="title2" data-testid="TextFieldWithLabel-Lable">
            {label}
          </Typography>
        </StyledFormLabel>
      )}
      <TextBoxWrapper>
        <StyleOutlinedTextbox
          disabled={disabled}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={helperText}
          type={type}
          inputProps={{ ...inputProps, 'data-testid': dataTestId }}
          multiline
          rows={rows}
          error={error}
          $width={width}
        />
      </TextBoxWrapper>
    </FormControl>
  </Box>
);

export default TextFieldWithLabel;
